import React from "react";
import { styled } from "@mui/material/styles";
import { DataGrid } from "@mui/x-data-grid";

const BaseStyledDataGrid = styled(DataGrid)(({ theme }) => ({
  "& .MuiDataGrid-columnHeaderTitle": {
    whiteSpace: "normal",
    textOverflow: "clip",
    fontWeight: "bold",
    lineHeight: "1",
  },
  "& .MuiDataGrid-columnHeader": {
    padding: 0,
    paddingLeft: theme.spacing(1),
    maxHeight: "32px",
  },
  "& .MuiDataGrid-toolbarContainer .MuiFormControl-root": {
    width: "100%",
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: theme.palette.dataGrid.headerBackgroundColor,
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: "bold",
      color: theme.palette.dataGrid.headerFontColor,
      whiteSpace: "nowrap",
      overflow: "visible",
      textOverflow: "clip",
    },
  },
  "& .MuiDataGrid-row": {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.dataGrid.rowOddBackgroundColor,
    },
  },
  "& .MuiDataGrid-overlayWrapper": {
    height: "5em",
  },
}));

const StyledDataGrid = (props) => (
  <BaseStyledDataGrid showToolbar columnHeaderHeight={32} {...props} />
);

export default StyledDataGrid;
